<template>
  <el-dialog
    :destroy-on-close="true"
    title="创建项目"
    :visible.sync="showDialog"
    width="900px">
    <el-form ref="projectAddForm" :model="projectAddFormData" label-width="170px" :rules="projectRule">
      <el-form-item label="项目识别码" prop="key" >
        <el-input v-model.trim="projectAddFormData.key" style="width: 80%"
                  placeholder="填写项目识别码">
        </el-input>
      </el-form-item>
      <el-form-item label="合同号信息" prop="contractNumber">
        <el-input v-model.trim="projectAddFormData.contractNumber" style="width: 80%"
                  placeholder="填写合同号信息">
        </el-input>
      </el-form-item>
      <div v-for="(customer,index) in customerList" :key="index+'customer'">
        <el-form-item :label="'客户'+(index+1)+'名称'" prop="customerName">
          <div style="display: flex">
            <el-input v-model.trim="customer.name" :maxlength="15" style="width: 80%"
                      placeholder="客户名称" :name="`customer_name${index}`"
                      v-validate="{required: true}">
            </el-input>
            <el-button style="margin-left: 20px" type="danger" plain @click="deleteCustomer(index)">删除客户
            </el-button>
          </div>

          <span class="el-form-item__error"
                v-show="errors.has(`customer_name${index}`)">
                {{ errors.first(`customer_name${index}`) ? '客户姓名不能为空' : '' }}
              </span>
        </el-form-item>
        <el-form-item :label="'客户'+(index+1)+'邮箱'" :required="true">
          <el-input v-model.trim="customer.mail" style="width: 80%" v-validate="{email:true,required: true}"
                    :name="`customer_email${index}`"
                    placeholder="客户邮箱">
          </el-input>
          <span class="el-form-item__error"
                v-show="errors.has(`customer_email${index}`)">{{ errors.first(`customer_email${index}`) }}</span>
        </el-form-item>
        <el-form-item :label="'客户'+(index+1)+'手机号码'" prop="customerPhone">
          <el-input v-model.trim="customer.phone" :maxlength="15" style="width: 80%"
                    placeholder="手机号码(选填)">
          </el-input>
        </el-form-item>
      </div>
      <el-form-item>
        <el-button type="success" plain @click="addCustomer()">新增客户</el-button>
      </el-form-item>
      <el-form-item label="类型">
        <el-input v-model.trim="projectAddFormData.category" style="width: 80%"
                  placeholder="填写类型">
        </el-input>
      </el-form-item>
      <el-form-item label="备注">
        <el-input v-model.trim="projectAddFormData.note" style="width: 80%"
                  placeholder="填写备注">
        </el-input>
      </el-form-item>
      <el-form-item label="微生物群落OTU表" :required="true">
        <upload :child-msg="uploadProperty" :show-file-list="false" @callFather="getOtuFile" :dataType="'SAMPLE'" class="uploadFileContainer"
                :exampleFileName="'otu_taxa_table.txt'"
                input-placeholder="请上传样本文件，格式为txt,xls" :component-style="1"
        ></upload>
      </el-form-item>
      <el-form-item label="微生物属水平OTU表" :required="true">
        <upload :child-msg="uploadProperty" :show-file-list="false" @callFather="getHorizontalOTUFile" class="uploadFileContainer"
                :exampleFileName="'genus.all.txt'"
                :component-style="1" ></upload>
      </el-form-item>
      <el-form-item label="代谢组数据" :required="true">
        <upload :child-msg="uploadProperty" :show-file-list="false" @callFather="getMetabolomicDataFile" class="uploadFileContainer"
                :exampleFileName="'all_sample_data.txt'"
                :component-style="1" ></upload>
      </el-form-item>
      <el-form-item label="差异代谢物信息" :required="true">
        <upload :show-file-list="true" @callFather="getDAMsFile" :child-msg="uploadProperty" class="uploadFileContainer"
                :exampleFileName="'DAMs.txt'"
                :component-style="1"  ></upload>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
        <div style="text-align: center">
          <el-button type="primary" @click="prepareAddProject">确 定</el-button>
          <el-button @click="prepareAddProject" style="margin-left: 20px"> 取 消</el-button>
        </div>
      </span>
  </el-dialog>
</template>

<script>
import {fastaSize, picrustSize, sampleSize, treeSize, zipSize} from '@/utils/uploadFileSize'
import { checkMail, checkNameOrEmptyRule, checkPhoneOrEmptyRule } from '@/utils/utils'
import { checkMd5 } from '@/utils/burstUpload'
import Upload from '@/components/Upload'

export default {
  name: 'AddProject',
  props:['showDialog'],
  components:{
    Upload
  },
  data(){
    return{
      checkedResZip:false,//是否有分析结果文件
      //新增项目表单信息
      projectAddFormData: {
        key:'',
        dataZip:'',
        rawLink:'',
        linkCode:'',
        customerName: '',
        customerPhone: '',
        contractNumber: '',
        customerMail: '',
        note: '',
        category: '',
        sampleFile: '',
        rawDataFile: '',
        otuFile: '',
        DAMsFile: '',
        picrustFile: '',
        resZip: '',
        metabolomicDataFile: '',
        horizontalOTUFile: '',
      },
      //新增项目信息表单验证
      projectRule: {
        customerPhone: [{
          validator: checkPhoneOrEmptyRule,
          trigger: 'blur'
        }],
        customerName: [{
          validator: checkNameOrEmptyRule,
          required: true,
          trigger: 'blur'
        }],
        key: [{
          required: true,
          message: '请输入项目识别码',
          trigger: 'blur'
        }],
        contractNumber: [{
          required: true,
          message: '请输入合同号编号',
          trigger: 'blur'
        }],
        customerMail: [{
          validator: checkMail,
          required: true,
          // message: '请输入客户邮箱账号',
          trigger: 'blur'
        }]
      },
      zip: {
        fileSize: zipSize,
        types: new Set(['rar', 'zip', 'arj', 'z', 'lzh', 'jar', '7z', '.dar', 'tar', 'gz'])
      },//zip的类型、大小
      uploadProperty: {
        fileSize: sampleSize,
        types: new Set(['txt', 'xls'])
      },
      uploadFastaProperty: {
        fileSize: fastaSize,
        types: new Set()
      },
      uploadTreeProperty: {
        fileSize: treeSize,
        types: new Set(['nwk', 'tre'])
      },
      uploadPicrustProperty: {
        fileSize: picrustSize,
        types: new Set(['txt', 'xls'])
      },
      uploadRowDataProperty: {
        fileSize: fastaSize,
        types: new Set()
      },
      sales:[],//销售信息
      saleList: [{
        id: '',
        name: ''
      }],//销售列
      customerList: [{
        name: '',
        mail: '',
        phone: ''
      }],//客户列
    }
  },
  methods:{
    addCustomer() {
      this.customerList.push({
        name: '',
        mail: '',
        phone: ''
      })
    },
    deleteCustomer(index) {
      const length = this.customerList.length
      if (length <= 1) {
        this.$messageUi.error("删除失败，至少得有一个客户")
      } else {
        this.customerList.splice(index, 1)
      }
    },
    getReUploadFile(file) {
      if (!file) {
        this.reUploadFile = ''
      } else {
        this.reUploadFile = file
      }
    },
    getOtuFile(file) {
      var that = this
      if (!file) {
        this.projectAddFormData.otuFile = ''
      } else {
        that.projectAddFormData.otuFile = file

      }
    },
    getHorizontalOTUFile(file) {
      if (!file) {
        this.projectAddFormData.horizontalOTUFile = ''
      } else {
        this.projectAddFormData.horizontalOTUFile = file
      }
    },
    getMetabolomicDataFile(file) {
      if (!file) {
        this.projectAddFormData.metabolomicDataFile = ''
      } else {
        this.projectAddFormData.metabolomicDataFile = file
      }

    },
    getDAMsFile(file) {
      console.log(file)
      if (!file) {
        this.projectAddFormData.DAMsFile = ''
      } else {
        this.projectAddFormData.DAMsFile = file
      }
    },
    prepareAddProject() {
      var that = this
      if (!this.projectAddFormData.key) {
        this.$messageUi.error('请填写项目识别码')
        return
      }
      if (!this.projectAddFormData.contractNumber) {
        this.$messageUi.error('请填写合同号编号')
        return
      }
      if (!this.projectAddFormData.otuFile) {
        this.$messageUi.error('微生物群落OTU表')
        return
      }
      if (!this.projectAddFormData.horizontalOTUFile) {
        this.$messageUi.error('微生物属水平OTU表')
        return
      }
      if (!this.projectAddFormData.metabolomicDataFile) {
        this.$messageUi.error('代谢组数据')
        return
      }
      if (!this.projectAddFormData.DAMsFile) {
        this.$messageUi.error('差异代谢物信息')
        return
      }
      this.$refs['projectAddForm'].validate(valid => {
        if (valid) {
          this.$validator.validateAll().then(result => {
            if (result) {
              this.normalProjectInfo().then(res=>{
                let {flag,...sendData}=res
                if(flag){
                  this.$emit('submit',sendData)
                }
              })
            } else {
              this.$messageUi.error('有参数不合法')
            }
          })

        }
      })
    },
    async normalProjectInfo(){
      let horizontalOTUFile,otuFile,metabolomicDataFile,DAMsFile = {}
      let formData = {
        flag:true
      }
      formData.note = this.projectAddFormData.note
      formData.contractNumber = this.projectAddFormData.contractNumber
      formData.customerList = this.customerList
      horizontalOTUFile = checkMd5(this.projectAddFormData.horizontalOTUFile)
      otuFile = checkMd5(this.projectAddFormData.otuFile)
      metabolomicDataFile = checkMd5(this.projectAddFormData.metabolomicDataFile)
      DAMsFile = checkMd5(this.projectAddFormData.DAMsFile)
      const [horizontalOTUFileResponse, otuFileResponse, metabolomicDataFileResponse, DAMsFileResponse,] = await Promise.all([horizontalOTUFile, otuFile, metabolomicDataFile,DAMsFile])
      let fileHash = [metabolomicDataFileResponse.file_md5, otuFileResponse.file_md5, horizontalOTUFileResponse.file_md5,DAMsFileResponse.file_md5]
      formData.otuFile = {
        'fileName': otuFileResponse.fileName,
        'hash': otuFileResponse.file_md5
      }
      formData.horizontalOTUFile = {
        'fileName': horizontalOTUFileResponse.fileName,
        'hash': horizontalOTUFileResponse.file_md5
      }
      formData.metabolomicDataFile = {
        'fileName': metabolomicDataFileResponse.fileName,
        'hash': metabolomicDataFileResponse.file_md5
      }
      formData.DAMsFile = {
        'fileName': DAMsFileResponse.fileName,
        'hash': DAMsFileResponse.file_md5
      }
      const fileHashSet = new Set(fileHash)
      if (fileHash.length !== fileHashSet.size) {
        this.$messageUi.error('有文件重复上传，请重新上传文件')
        this.isShowAddLoading = false
        formData.flag=false
      }
      return formData
    },
  }
}
</script>

<style scoped>

</style>
